import * as actionTypes from "./orderTypes";

const INITIAL_STATE = {
    salesOrderList: null,
    salesOrderInfo: null,
    attachmentList: [],
    equipmentList: [],
    itemList: [],
    addressList: [],
    statusList: [],
    equipmentPartsList: [],
    sqSoComparison: [],
    salesOrderItems: [],
    salesQuote: null,
    emailContent: null,
    previewReport: [],
};

const orderReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETSALESORDERLIST:
            return {
                ...state,
                salesOrderList: action.payload.list,
            };
        case actionTypes.SETSQSOCOMPARISON:
            return {
                ...state,
                sqSoComparison: action.payload.list,
            };
        case actionTypes.SETSALESORDERINFO:
            return {
                ...state,
                salesOrderInfo: action.payload.list,
            };
        case actionTypes.SETSALESORDERITEMS:
            return {
                ...state,
                salesOrderItems: action.payload.list,
            };
        case actionTypes.SETATTACHMENTLIST:
            return {
                ...state,
                attachmentList: action.payload.list,
            };
        case actionTypes.SETEQUIPMENTLIST:
            return {
                ...state,
                equipmentList: action.payload.list,
            };
        case actionTypes.SETITEMLIST:
            return {
                ...state,
                itemList: action.payload.list,
            };
        case actionTypes.SETADDRESSLIST:
            return {
                ...state,
                addressList: action.payload.list,
            };
        case actionTypes.SETEQUIPMENTPARTSLIST:
            return {
                ...state,
                equipmentPartsList: action.payload.list,
            };
        case actionTypes.SETSTATUSLIST:
            return {
                ...state,
                statusList: action.payload.list,
            };
        case actionTypes.SETEMAILCONTENTLIST:
            return {
                ...state,
                emailContent: action.payload.list,
            };
        case actionTypes.SOCLEARDOC:
            return {
                ...state,
                salesOrderInfo: null, attachmentList: null, quoteCopyToOrder: null
            };
        case actionTypes.SETPREVIEWREPORT:
            return {
                ...state,
                previewReport:action.payload.list
            };
        default:
            return state;
    }
};

export default orderReducer;
